/**
 * Section: Hub Fleurs botté (navigation catégories / sous-catégories / couleurs / liens produits)
 */

(function () {
  'use strict';

  function getQueryParam(name) {
    try {
      var params = new URLSearchParams(window.location.search || '');
      return params.get(name);
    } catch (err) {
      return null;
    }
  }

  function normalizeSearch(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/œ/g, 'oe')
      .replace(/æ/g, 'ae')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[-_]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function parseColorList(value) {
    return String(value || '')
      .split(',')
      .map(function (s) { return s.trim().toLowerCase(); })
      .filter(Boolean);
  }

  function sortVisibleProducts(container, order) {
    var wrap = container.querySelector('.fb-hub__products');
    if (!wrap) return;
    var nodes = Array.prototype.slice.call(wrap.querySelectorAll('[data-fb-product]'));
    var visible = nodes.filter(function (a) {
      return !a.hidden;
    });
    var hidden = nodes.filter(function (a) {
      return a.hidden;
    });
    visible.sort(function (a, b) {
      var la = a.querySelector('.fb-hub__product-label') || a.querySelector('.product-item__title');
      var lb = b.querySelector('.fb-hub__product-label') || b.querySelector('.product-item__title');
      var ta = la ? la.textContent.trim() : (a.textContent || '').trim();
      var tb = lb ? lb.textContent.trim() : (b.textContent || '').trim();
      if (order === 'za') return tb.localeCompare(ta, 'fr', { sensitivity: 'base' });
      return ta.localeCompare(tb, 'fr', { sensitivity: 'base' });
    });
    visible.concat(hidden).forEach(function (node) {
      wrap.appendChild(node);
    });
  }

  function initHubNavigator(container) {
    if (!container || container.dataset.hubNavBound === '1') return;
    if (container.getAttribute('data-fb-hub-mode') !== 'link') return;

    var dialog = container.querySelector('[data-fb-filter-dialog]');
    var hasColorFilter = !!container.querySelector('[data-fb-color]');

    function catButtons() {
      return container.querySelectorAll('[data-fb-cat][data-fb-cat-key]');
    }
    function subcatCards() {
      return container.querySelectorAll('[data-fb-subcat][data-fb-subcat-key]');
    }
    function productLinks() {
      return container.querySelectorAll('[data-fb-product]');
    }
    function colorButtons() {
      return container.querySelectorAll('[data-fb-color][data-fb-color-key]');
    }

    var cats = catButtons();

    if (!cats.length || !productLinks().length) return;

    var qsCat = getQueryParam('fb_cat');
    var qsSub = getQueryParam('fb_sub');
    var qsProd = getQueryParam('fb_product');
    var qsColors = parseColorList(getQueryParam('fb_color'));

    var state = {
      catKey: 'all',
      subKey: null,
      subMode: false,
      colors: qsColors.slice(),
      query: ''
    };

    function setQueryParams(next) {
      try {
        var u = new URL(window.location.href);
        Object.keys(next).forEach(function (k) {
          var v = next[k];
          if (v === null || v === undefined || v === '') u.searchParams.delete(k);
          else u.searchParams.set(k, v);
        });
        window.history.replaceState({}, '', u.toString());
        document.dispatchEvent(new CustomEvent('fb-hub:change', {
          detail: {
            cat: u.searchParams.get('fb_cat') || '',
            sub: u.searchParams.get('fb_sub') || '',
            product: u.searchParams.get('fb_product') || '',
            color: u.searchParams.get('fb_color') || ''
          }
        }));
      } catch (err) {
        // ignore
      }
    }

    function updateProductCount() {
      var el = container.querySelector('[data-fb-product-count]');
      if (!el) return;
      var n = 0;
      productLinks().forEach(function (a) {
        if (!a.hidden) n += 1;
      });
      el.textContent = String(n);
    }

    function productMatchesCategory(a) {
      var pSub = a.getAttribute('data-fb-parent-subcat') || '';
      var pCat = a.getAttribute('data-fb-parent-cat') || '';

      if (state.catKey === 'all') {
        return true;
      }
      if (state.subMode && state.subKey) {
        return pSub === state.subKey;
      }
      return pSub === '' && pCat === state.catKey;
    }

    function productMatchesQuery(a) {
      if (!state.query) return true;
      var label = a.querySelector('.fb-hub__product-label') || a.querySelector('.product-item__title');
      var name = normalizeSearch(label ? label.textContent : '');
      var words = state.query.split(' ').filter(Boolean);
      return words.every(function (word) {
        return name.indexOf(word) !== -1;
      });
    }

    function productMatchesColor(a) {
      if (!hasColorFilter || !state.colors.length) {
        return true;
      }
      var prodColors = parseColorList(a.getAttribute('data-fb-colors'));
      if (!prodColors.length) {
        return false;
      }
      return state.colors.some(function (c) {
        return prodColors.indexOf(c) >= 0;
      });
    }

    function applyAllFilters() {
      productLinks().forEach(function (a) {
        a.hidden = !(productMatchesCategory(a) && productMatchesColor(a) && productMatchesQuery(a));
      });
      updateProductCount();
      var sortEl = container.querySelector('[data-fb-sort]');
      if (sortEl) sortVisibleProducts(container, sortEl.value || 'az');
    }

    function setActiveCat(btn) {
      if (!btn) return;
      var key = btn.getAttribute('data-fb-cat-key') || '';
      catButtons().forEach(function (b) {
        var active = (b.getAttribute('data-fb-cat-key') || '') === key;
        b.classList.toggle('is-active', active);
        if (b.getAttribute('role') === 'tab') {
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        }
      });
    }

    function setActiveSubcat(card) {
      if (!card) {
        subcatCards().forEach(function (c) {
          c.classList.remove('is-selected');
          c.setAttribute('aria-pressed', 'false');
        });
        return;
      }
      var key = card.getAttribute('data-fb-subcat-key') || '';
      subcatCards().forEach(function (c) {
        var active = (c.getAttribute('data-fb-subcat-key') || '') === key;
        c.classList.toggle('is-selected', active);
        c.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function setActiveProductLink(el) {
      productLinks().forEach(function (a) {
        var active = el && a === el;
        a.classList.toggle('is-selected', !!active);
      });
    }

    function syncColorButtons() {
      if (!hasColorFilter) return;
      var allActive = !state.colors.length;
      colorButtons().forEach(function (btn) {
        var key = btn.getAttribute('data-fb-color-key') || '';
        var active = key === 'all' ? allActive : state.colors.indexOf(key) >= 0;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function setColors(nextColors) {
      state.colors = nextColors.slice();
      syncColorButtons();
      setQueryParams({ fb_color: state.colors.length ? state.colors.join(',') : '' });
      applyAllFilters();
    }

    function resetColors() {
      setColors([]);
    }

    function toggleColor(key) {
      if (!key || key === 'all') {
        resetColors();
        return;
      }
      var idx = state.colors.indexOf(key);
      if (idx >= 0) {
        state.colors.splice(idx, 1);
      } else {
        state.colors.push(key);
      }
      syncColorButtons();
      setQueryParams({ fb_color: state.colors.length ? state.colors.join(',') : '' });
      applyAllFilters();
    }

    function filterSubcats(catKey) {
      if (!catKey || catKey === 'all') {
        subcatCards().forEach(function (card) {
          card.hidden = true;
        });
        return null;
      }
      var firstVisible = null;
      subcatCards().forEach(function (card) {
        var parent = card.getAttribute('data-fb-parent-cat') || '';
        var visible = parent === catKey;
        card.hidden = !visible;
        if (visible && !firstVisible) firstVisible = card;
      });
      return firstVisible;
    }

    function findCatByKey(key) {
      var found = null;
      catButtons().forEach(function (b) {
        if (found) return;
        if ((b.getAttribute('data-fb-cat-key') || '') === key) found = b;
      });
      return found;
    }

    function findSubcatByKey(key) {
      var found = null;
      subcatCards().forEach(function (c) {
        if (found) return;
        if ((c.getAttribute('data-fb-subcat-key') || '') === key) found = c;
      });
      return found;
    }

    function findProductByKey(key) {
      var found = null;
      productLinks().forEach(function (a) {
        if (found) return;
        if ((a.getAttribute('data-fb-product-key') || '') === key) found = a;
      });
      return found;
    }

    function selectSubcat(subCard, highlightProductKey) {
      if (!subCard) return;
      state.subMode = true;
      state.subKey = subCard.getAttribute('data-fb-subcat-key') || '';
      setActiveSubcat(subCard);
      setQueryParams({ fb_sub: state.subKey });
      applyAllFilters();

      if (highlightProductKey) {
        var pl = findProductByKey(highlightProductKey);
        if (pl && !pl.hidden) setActiveProductLink(pl);
      } else {
        setActiveProductLink(null);
      }
    }

    function selectCat(catBtn, opts) {
      if (!catBtn) return;
      state.catKey = catBtn.getAttribute('data-fb-cat-key') || '';
      setActiveCat(catBtn);

      if (state.catKey === 'all') {
        state.subMode = false;
        state.subKey = null;
        setActiveSubcat(null);
        filterSubcats(state.catKey);
        setActiveProductLink(null);
        setQueryParams({ fb_sub: '', fb_product: '' });
        applyAllFilters();
        setQueryParams({ fb_cat: state.catKey });
        return;
      }

      var requestedSub = opts && opts.subKey ? findSubcatByKey(opts.subKey) : null;
      var subToSelect = null;
      if (requestedSub && (requestedSub.getAttribute('data-fb-parent-cat') || '') === state.catKey) {
        filterSubcats(state.catKey);
        subToSelect = requestedSub;
      } else {
        subToSelect = filterSubcats(state.catKey);
      }

      if (subToSelect) {
        selectSubcat(subToSelect, opts && opts.productKey ? opts.productKey : null);
      } else {
        state.subMode = false;
        state.subKey = null;
        setActiveSubcat(null);
        setQueryParams({ fb_sub: '' });
        if (opts && opts.productKey) {
          var pl = findProductByKey(opts.productKey);
          applyAllFilters();
          if (pl && !pl.hidden) setActiveProductLink(pl);
          else setActiveProductLink(null);
        } else {
          setActiveProductLink(null);
          applyAllFilters();
        }
      }

      setQueryParams({ fb_cat: state.catKey });
    }

    container.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-fb-open-filter]')) {
        e.preventDefault();
        if (dialog && typeof dialog.showModal === 'function') {
          dialog.showModal();
        }
        return;
      }
      if (t.closest('[data-fb-close-filter]')) {
        e.preventDefault();
        if (dialog && typeof dialog.close === 'function') dialog.close();
        return;
      }
      if (t.closest('[data-fb-reset-colors]')) {
        e.preventDefault();
        resetColors();
        return;
      }

      var colorBtn = t.closest('[data-fb-color][data-fb-color-key]');
      if (colorBtn && container.contains(colorBtn)) {
        e.preventDefault();
        toggleColor(colorBtn.getAttribute('data-fb-color-key') || '');
        return;
      }

      var catBtn = t.closest('[data-fb-cat][data-fb-cat-key]');
      if (catBtn && container.contains(catBtn)) {
        e.preventDefault();
        selectCat(catBtn, { subKey: null, productKey: null });
        return;
      }

      var subCard = t.closest('[data-fb-subcat][data-fb-subcat-key]');
      if (subCard && container.contains(subCard)) {
        e.preventDefault();
        var parentCat = subCard.getAttribute('data-fb-parent-cat') || '';
        var parentBtn = findCatByKey(parentCat);
        if (parentBtn) {
          setActiveCat(parentBtn);
          state.catKey = parentCat;
          filterSubcats(parentCat);
          setQueryParams({ fb_cat: parentCat });
        }
        selectSubcat(subCard, null);
        if (dialog && subCard.closest && subCard.closest('[data-fb-filter-dialog]')) {
          dialog.close();
        }
      }
    });

    var sortEl = container.querySelector('[data-fb-sort]');
    if (sortEl) {
      sortEl.addEventListener('change', function () {
        sortVisibleProducts(container, sortEl.value || 'az');
      });
    }

    var searchEl = container.querySelector('[data-fb-search]');
    if (searchEl) {
      searchEl.addEventListener('input', function () {
        state.query = normalizeSearch(searchEl.value);
        applyAllFilters();
      });
    }

    if (dialog) {
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) dialog.close();
      });
    }

    container.dataset.hubNavBound = '1';

    syncColorButtons();

    var startCat = (qsCat && findCatByKey(qsCat)) || catButtons()[0];
    selectCat(startCat, { subKey: qsSub, productKey: qsProd });
  }

  function run() {
    document.querySelectorAll('.fb-hub[data-fb-hub-mode="link"]').forEach(function (el) {
      initHubNavigator(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector && e.target.querySelector('.fb-hub[data-fb-hub-mode="link"]');
    if (root) initHubNavigator(root);
  });
})();
